<div style="position: relative; width: 170px;">
    <input type="date" id="date" [(ngModel)]="date" [disabled]="isDisabled" name="date" 
        (change)="submitDate()" class="date-picker" />
</div>
